import { resolvePageName } from "./resolvePageName";

const DASHBOARD_DIMENSIONS = {
  RETAIL: "Retail Banking",
  COMMERCIAL: "Commercial Banking",
  BANK_PERFORMANCE_METRICS: "Bank Performance Metrics",
  ANALYST: "Analyst",
};

export const resolveDashboardDimension = (
  currentDashboard,
  currentPath = globalThis?.location?.pathname || "",
) => {
  const pageName = resolvePageName(currentPath);
  if (pageName === "Analyst Dashboard Page") {
    return DASHBOARD_DIMENSIONS.ANALYST;
  }
  if (
    pageName === "Bank Performance Metrics Page" ||
    pageName === "User Management Page"
  ) {
    return DASHBOARD_DIMENSIONS.BANK_PERFORMANCE_METRICS;
  }

  const dashboardKey = String(currentDashboard?.KEY || "").toUpperCase();
  if (dashboardKey === "1" || dashboardKey === "RETAIL") {
    return DASHBOARD_DIMENSIONS.RETAIL;
  }
  if (dashboardKey === "2" || dashboardKey === "COMMERCIAL") {
    return DASHBOARD_DIMENSIONS.COMMERCIAL;
  }

  const dashboardName =
    typeof currentDashboard === "string"
      ? currentDashboard
      : currentDashboard?.CONFIG?.pageHeader?.pageTitle ||
        currentDashboard?.NAME ||
        "";
  if (/^retail(?: banking)?(?: dashboard)?$/i.test(dashboardName)) {
    return DASHBOARD_DIMENSIONS.RETAIL;
  }
  if (/^commercial(?: banking)?(?: dashboard)?$/i.test(dashboardName)) {
    return DASHBOARD_DIMENSIONS.COMMERCIAL;
  }
  if (/^analyst dashboard(?: page)?$/i.test(dashboardName)) {
    return DASHBOARD_DIMENSIONS.ANALYST;
  }

  return DASHBOARD_DIMENSIONS.BANK_PERFORMANCE_METRICS;
};

export default resolveDashboardDimension;
